/**
 * Constants related to specific data sources.
 */

import { AreaEmissionsProducts, MethaneEmissionsProducts, MethaneLayerIds, Platforms } from '../types';
import { EMISSION_DB_URL, INFRASTRUCTURE_API_BASE_URL, TITILER_URL } from '../environmentVariables';

export const OPERATOR_NAMES_URL = `${INFRASTRUCTURE_API_BASE_URL}/visible_bounded_operator_list`;
export const INFRASTRUCTURE_DATA_VERSION_URL = `${INFRASTRUCTURE_API_BASE_URL}/database_current_state`;

/**
 * Link to paper via EDF Science (May 2024).
 * See https://methanesat.atlassian.net/browse/DP-3023?focusedCommentId=20452
 */
export const OGIM_DATA_SOURCE_URL = 'https://zenodo.org/records/15103476';

export const METHANESAT_FAQ_URL = 'https://www.methanesat.org/frequently-asked-questions';

export const METHANESAT_TECHNICAL_PDF_URL =
    'https://www.methanesat.org/sites/default/files/2026-07/MethaneSAT%20Dispersed%20Area%20Emissions%20Definitions%20and%20Limitations.pdf';
export const FAQ_DISPERSED_SOURCES = '#what-are-emissions-dispersed-area-sources';
export const FAQ_DISTINCT_SOURCES = '#what-are-emissions-distinct-point-sources';
export const FAQ_HOW_TO_INTERPRET = '#how-should-i-interpret-dispersed-area-emissions';
export const FAQ_ALGORITHM_VERSION = '#what-do-algorithm-version-numbers-mean';

/** map of data sources */
export const dataSources = {
    [MethaneLayerIds.areaEmissionRaster]: {
        url: {
            titilerUrl: TITILER_URL,
            targetsUrl: EMISSION_DB_URL
        }
    }
} as const;

// L3 uses meters, L4 uses kilometers because L3 data is at a much higher resolution
export const PLATFORM_RASTER_SIZE = {
    [Platforms.MAIR]: {
        [AreaEmissionsProducts.l3]: 20,
        [AreaEmissionsProducts.l4]: 1
    },
    [Platforms.MSAT]: {
        [AreaEmissionsProducts.l3]: 90,
        [AreaEmissionsProducts.l4]: 5
    }
};

/** Values must point to keys of `emissionsMapPage.units` in `locales/en-emissionsMap.json` */
export const EMISSIONS_PRODUCT_UNITS = {
    [MethaneEmissionsProducts.l3]: 'ppb',
    [MethaneEmissionsProducts.l4]: 'kgHrKm2',
    [MethaneEmissionsProducts.plume]: 'kgHr',
    [MethaneEmissionsProducts.target]: 'kgHr'
};

export const PLUME_EMISSION_DETECTION_THRESHOLD = {
    [Platforms.MAIR]: 200,
    [Platforms.MSAT]: 500
};
